export default "skymp5-front/7368c872f5c628c86f6a52fbd83e5e36.svg";